import { Component } from '@wordpress/element';

class IconImage extends Component {
	render() {
		const { attributes } = this.props;

		let urlChk = '';
		if ( typeof attributes.iconImage !== 'undefined' && attributes.iconImage !== null && attributes.iconImage !== '' ) {
			urlChk = attributes.iconImage.url;
		}

		let url = '';
		if ( urlChk !== '' ) {
			const size = attributes.iconImage.sizes;
			const imageSize = attributes.imageSize;

			if ( typeof size !== 'undefined' && typeof size[ imageSize ] !== 'undefined' ) {
				url = size[ imageSize ].url;
			} else {
				url = urlChk;
			}

			return (
				<img
					className=""
					src={ url }
					alt={ attributes.iconImage.alt }
				/>
			);
		}
		return null;
	}
}

export default IconImage;
